import { MutableRefObject } from 'react'

import ApiResponse from '@/models/ApiResponse'
import { Product2 } from '@/models/Product'
import { get } from '@/utils/axios'
const fetchAllProducts = async ({
  query,
  abortRef,
}: {
  query: string
  abortRef?: MutableRefObject<AbortController | null>
}) => {
  return await get<ApiResponse<Product2>>(
    `/hyperlocal/v1/products?${query}`,
    {},
    undefined,
    abortRef?.current?.signal,
  )
}

export default fetchAllProducts
